import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import "react-quill/dist/quill.snow.css";
import "react-phone-input-2/lib/style.css";
import { PersistGate } from "redux-persist/integration/react";

import { BrowserRouter } from "react-router-dom";
// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ur from "./locales/ur.json";
import ar from "./locales/ar.json";
import bg from "./locales/bg.json";
import ca from "./locales/ca.json";
import zh_CN from "./locales/zh_CN.json";
import zh_TW from "./locales/zh_TW.json";
import hr from "./locales/hr.json";
import cs from "./locales/cs.json";
import da from "./locales/da.json";
import nl from "./locales/nl.json";
import en_GB from "./locales/en_GB.json";
import en_US from "./locales/en_US.json";
import et from "./locales/et.json";
import fi from "./locales/fi.json";
import fr_CA from "./locales/fr_CA.json";
import fr_FR from "./locales/fr_FR.json";
import de from "./locales/de.json";
import el from "./locales/el.json";
import he from "./locales/he.json";
import hi from "./locales/hi.json";
import hu from "./locales/hu.json";
import id from "./locales/id.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import lv from "./locales/lv.json";
import lt from "./locales/lt.json";
import ms from "./locales/ms.json";
import nb from "./locales/nb.json";
import pl from "./locales/pl.json";
import pt_BR from "./locales/pt_BR.json";
import pt_PT from "./locales/pt_PT.json";
import ro from "./locales/ro.json";
import ru from "./locales/ru.json";
import sk from "./locales/sk.json";
import sl from "./locales/sl.json";
import es_MX from "./locales/es_MX.json";
import es_ES from "./locales/es_ES.json";
import sv from "./locales/sv.json";
import th from "./locales/th.json";
import tr from "./locales/tr.json";
import uk from "./locales/uk.json";
import vi from "./locales/vi.json";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const storedLanguage = localStorage.getItem("language") || "en_GB";

i18n.use(initReactI18next).init({
  resources: {
    ur: { translation: ur }, //urdu
    ar: { translation: ar }, //arabic
    bg: { translation: bg }, //Bulgarian
    ca: { translation: ca }, //ca
    zh_CN: { translation: zh_CN }, //zh_CN
    zh_TW: { translation: zh_TW }, //zh_TW
    hr: { translation: hr }, //hr
    cs: { translation: cs }, //cs
    da: { translation: da }, //da
    nl: { translation: nl }, //nl
    en_GB: { translation: en_GB }, //en_GB
    en: { translation: en_GB }, //en_GB
    en_US: { translation: en_US }, //en_US
    et: { translation: et }, //et
    fi: { translation: fi }, //fi
    fr_CA: { translation: fr_CA }, //fr_CA
    fr_FR: { translation: fr_FR }, //fr_FR
    de: { translation: de }, //de
    el: { translation: el }, //el
    he: { translation: he }, //he
    hi: { translation: hi }, //hi
    hu: { translation: hu }, //hu
    id: { translation: id }, //id
    it: { translation: it }, //it
    ja: { translation: ja }, //ja
    ko: { translation: ko }, //ko
    lv: { translation: lv }, //lv
    lt: { translation: lt }, //lt
    ms: { translation: ms }, //ms
    nb: { translation: nb }, //nb
    pl: { translation: pl }, //pl
    pt_BR: { translation: pt_BR }, //pt_BR
    pt_PT: { translation: pt_PT }, //pt_PT
    ro: { translation: ro }, //ro
    ru: { translation: ru }, //ru
    sk: { translation: sk }, //sk
    sl: { translation: sl }, //sl
    es_MX: { translation: es_MX }, //es_MX
    es_ES: { translation: es_ES }, //es_ES
    sv: { translation: sv }, //sv
    th: { translation: th }, //th
    tr: { translation: tr }, //tr
    uk: { translation: uk }, //uk
    vi: { translation: vi }, //vi
  },
  lng: storedLanguage, // language to use .....Default is english
  interpolation: {
    escapeValue: false,
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
